import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, Link } from "react-router-dom";

const styles = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
        color: "#e7e7e9",
        padding: "48px 16px 72px",
        fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box",
    },
    container: {
        maxWidth: "960px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "18px",
    },
    card: {
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.07)",
        boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
        borderRadius: "16px",
        padding: "22px 20px",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
    },
    title: {
        margin: 0,
        fontSize: "28px",
        fontWeight: 800,
        color: "#fff",
        letterSpacing: "-0.02em",
    },
    helper: {
        color: "#cbd5e1",
        fontSize: "13px",
    },
    list: {
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
    item: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "14px 16px",
        borderRadius: "12px",
        border: "1px solid rgba(255,255,255,0.08)",
        background: "rgba(255,255,255,0.03)",
        transition: "transform 0.16s ease, border-color 0.18s ease",
    },
    itemHover: {
        transform: "translateY(-2px)",
        borderColor: "rgba(249,115,22,0.35)",
    },
    itemTitle: {
        color: "#ef4444",
        fontWeight: 700,
        fontSize: "16px",
        textDecoration: "none",
        letterSpacing: "-0.01em",
    },
    itemDate: {
        color: "#cbd5e1",
        fontSize: "13px",
        marginLeft: "12px",
        whiteSpace: "nowrap",
    },
    primaryBtn: {
        padding: "12px 16px",
        borderRadius: "12px",
        border: "1px solid rgba(255,255,255,0.12)",
        background: "linear-gradient(120deg, #fb923c, #f97316)",
        color: "#130903",
        fontWeight: 800,
        cursor: "pointer",
        boxShadow: "0 12px 28px rgba(249,115,22,0.26)",
    },
    ghostLink: {
        color: "#fb923c",
        fontWeight: 700,
        textDecoration: "none",
    },
};

const Notice = () => {
    const [cookies] = useCookies(["uuid"]);
    const [notices, setNotices] = useState([]);
    const [superUser, setSuperUser] = useState(0); // 기본값: 일반 사용자
    const navigate = useNavigate();

    useEffect(() => {
        // 1️⃣ 공지사항 목록 불러오기
        fetch("/notices")
            .then((res) => res.json())
            .then((data) => setNotices(data))
            .catch((err) => console.error("공지사항 불러오기 오류:", err));

        // 2️⃣ 로그인된 사용자 정보 확인
        const uuid = cookies.uuid;
        if (uuid) {
            fetch(`/SetPage/admin_user?uuid=${uuid}`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("서버 응답 실패");
                    }
                    return response.json();
                })
                .then((data) => {
                    const user = data[0];
                    if (user && (user.super_user === 1 || user.super_user === "1")) {
                        setSuperUser(1);
                    } else {
                        setSuperUser(0);
                    }
                })
                .catch((err) => console.error("사용자 정보 불러오기 오류:", err));
        }
    }, [cookies]);

    const handleWrite = () => {
        navigate("/NoticeWrite");
    };

    const formatDate = (value) => {
        if (!value) return "";
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return "";
        return d.toLocaleDateString();
    };

    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <div style={{ ...styles.card, ...styles.header }}>
                    <h1 style={styles.title}>공지사항</h1>
                    <span style={styles.helper}>새 소식을 확인하세요</span>
                </div>

                <div style={styles.card}>
                    {notices.length > 0 ? (
                        <ul style={styles.list}>
                            {notices.map((notice) => (
                                <li
                                    key={notice.id}
                                    style={styles.item}
                                    onMouseEnter={(e) =>
                                        Object.assign(e.currentTarget.style, styles.itemHover)
                                    }
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "none";
                                        e.currentTarget.style.borderColor =
                                            styles.item.border.split(":")[1].trim();
                                    }}
                                >
                                    <Link
                                        to={`/Notice/${notice.id}`}
                                        style={{
                                            display: "flex",
                                            width: "100%",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            textDecoration: "none",
                                        }}
                                    >
                                        <span style={styles.itemTitle}>{notice.title}</span>
                                        <span style={styles.itemDate}>{formatDate(notice.created_at)}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p style={styles.helper}>등록된 공지사항이 없습니다.</p>
                    )}
                </div>

                <div style={styles.header}>
                    <Link to="/" style={styles.ghostLink}>
                        ← 메인으로
                    </Link>
                    {superUser === 1 && (
                        <button style={styles.primaryBtn} onClick={handleWrite}>
                            새 글 등록
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Notice;
